import { DocumentFilterParams, DocumentMonthSummaryDto } from '@taxora-shared-common/util';

export class BusinessLoadMonths {
  static readonly type = '[BusinessDocuments] LoadMonths';
  constructor(
    public relationshipId: number,
    public organizationId: number,
    public filters?: Omit<DocumentFilterParams, 'year' | 'month' | 'page' | 'limit'>,
  ) {}
}

export class BusinessLoadDocuments {
  static readonly type = '[BusinessDocuments] LoadDocuments';
  constructor(
    public relationshipId: number,
    public organizationId: number,
    public year: number | null,
    public month: number | null,
    public filters?: DocumentFilterParams,
  ) {}
}

export class BusinessLoadDocument {
  static readonly type = '[BusinessDocuments] LoadDocument';
  constructor(public id: number) {}
}

export class CreateDocument {
  static readonly type = '[BusinessDocuments] CreateDocument';
  constructor(
    public payload: {
      file: File;
      organizationRelationshipId: number;
      type: string;
      documentDate?: string;
      reference?: string;
      supplierName?: string;
      supplierCui?: number;
      value?: number;
      currency?: string;
      businessNote?: string;
    },
  ) {}
}

export class RemoveDocument {
  static readonly type = '[BusinessDocuments] RemoveDocument';
  constructor(
    public id: number,
    public reason: string,
  ) {}
}

export class BusinessCreateClarification {
  static readonly type = '[BusinessDocuments] CreateClarification';
  constructor(
    public id: number,
    public message: string,
  ) {}
}

export class UpdateBusinessNote {
  static readonly type = '[BusinessDocuments] UpdateBusinessNote';
  constructor(
    public id: number,
    public note: string | null,
  ) {}
}

export class BusinessExportMonth {
  static readonly type = '[BusinessDocuments] ExportMonth';
  constructor(
    public month: DocumentMonthSummaryDto,
    public relationshipId: number,
    public organizationId: number,
  ) {}
}

export class BusinessDownloadMonth {
  static readonly type = '[BusinessDocuments] DownloadMonth';
  constructor(
    public month: DocumentMonthSummaryDto,
    public relationshipId: number,
    public organizationId: number,
  ) {}
}

export class BusinessMarkMissingDocumentRequestSubmitted {
  static readonly type = '[BusinessDocuments] MarkMissingDocumentRequestSubmitted';
  constructor(public id: number) {}
}

export class BusinessOpenDrawer {
  static readonly type = '[BusinessDocuments] OpenDrawer';
  constructor(public id: number) {}
}

export class BusinessCloseDrawer {
  static readonly type = '[BusinessDocuments] CloseDrawer';
}

export class BusinessResetDocuments {
  static readonly type = '[BusinessDocuments] ResetDocuments';
}
